import { render, staticRenderFns } from "./AscentGymRouteLine.vue?vue&type=template&id=05ff9ddf"
import script from "./AscentGymRouteLine.vue?vue&type=script&lang=js"
export * from "./AscentGymRouteLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports